var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 9.66634V14.6663M9.66634 12.1663H14.6663M2.99967 6.33301H4.66634C5.58682 6.33301 6.33301 5.58682 6.33301 4.66634V2.99967C6.33301 2.0792 5.58682 1.33301 4.66634 1.33301H2.99967C2.0792 1.33301 1.33301 2.0792 1.33301 2.99967V4.66634C1.33301 5.58682 2.0792 6.33301 2.99967 6.33301ZM11.333 6.33301H12.9997C13.9201 6.33301 14.6663 5.58682 14.6663 4.66634V2.99967C14.6663 2.0792 13.9201 1.33301 12.9997 1.33301H11.333C10.4125 1.33301 9.66634 2.0792 9.66634 2.99967V4.66634C9.66634 5.58682 10.4125 6.33301 11.333 6.33301ZM2.99967 14.6663H4.66634C5.58682 14.6663 6.33301 13.9201 6.33301 12.9997V11.333C6.33301 10.4125 5.58682 9.66634 4.66634 9.66634H2.99967C2.0792 9.66634 1.33301 10.4125 1.33301 11.333V12.9997C1.33301 13.9201 2.0792 14.6663 2.99967 14.6663Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6c7f5a2cdb9ccaacc6dc6001e6a5d414.svg";
export { ForwardRef as ReactComponent };